import { FormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

export function emailValidator(control: FormControl): { email: true } | null {
  const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return isEmpty(control.value) || EMAIL_PATTERN.test(control.value) ? null : { email: true };
}
